import * as React from 'react';
import styled from 'styled-components';
import { IconButton } from '@ui/shared/Button';
import { Input } from './Input';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  style?: React.CSSProperties;
  testId?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

export const SearchInput = (props: IProps): React.ReactElement => {
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void =>
    props.onChange(e.target.value);
  return (
    <Container>
      <Input
        className='searchBar'
        name='search'
        value={props.value}
        onChange={changeHandler}
        placeholder='Search...'
        style={{ marginLeft: '10px', ...props.style }}
        data-testid={props.testId}
      />
      {props.value?.length > 0 && (
        <IconButton
          icon='clear'
          onClick={props.onClear}
          title='Clear'
          style={{ position: 'absolute', right: 0 }}
        />
      )}
    </Container>
  );
};
